import React from "react";
import {
  trays, chairs, neons, sunumluklar, columns,
  sehpalar, mumluklar, shamdanlar, benchler,
  vazolar, pastastandlari,
} from "../data/itemsList";

const categories = {
  Tepsiler: trays,
  Sandalyeler: chairs,
  Neonlar: neons,
  Sunumluklar: sunumluklar,
  Sütunlar: columns,
  Sehpalar: sehpalar,
  Mumluklar: mumluklar,
  Şamdanlar: shamdanlar,
  Benchler: benchler,
  Vazolar: vazolar,
  "Pasta Standları": pastastandlari
};

function MaterialPickerModal({ isOpen, onClose, onSelect, items = null }) {
  if (!isOpen) return null;

  const dataToShow = items
    ? { "Malzemeler": items } // sadece ilgili kategori
    : categories; // tüm kategoriler

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h3 style={styles.title}>Malzeme Seç</h3>

        <div style={styles.scroll}>
          {Object.entries(dataToShow).map(([catName, items]) => (
            <div key={catName}>
              <h4 style={styles.category}>{catName}</h4>
              <div style={styles.grid}>
                {items.map((item, i) => (
                  <div
                    key={i}
                    style={styles.card}
                    onClick={() => {
                      onSelect({ name: item.name, checked: true });
                      onClose();
                    }}
                  >
                    <img src={item.image} alt={item.name} style={styles.image} />
                    <p style={styles.name}>{item.name}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <button style={styles.closeBtn} onClick={onClose}>Kapat</button>
      </div>
    </div>
  );
}

const styles = {
  backdrop: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex", justifyContent: "center", alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    background: "#fff", padding: "20px", borderRadius: "8px",
    width: "95%", maxWidth: "900px", maxHeight: "90vh",
    overflowY: "auto",
  },
  title: {
    fontSize: "20px", marginBottom: "16px",
  },
  scroll: {
    maxHeight: "70vh", overflowY: "auto",
  },
  category: {
    fontSize: "16px", fontWeight: "bold", marginTop: "12px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
    gap: "10px",
    marginBottom: "16px",
  },
  card: {
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    padding: "8px",
    textAlign: "center",
    cursor: "pointer",
    transition: "0.2s",
  },
  image: {
    width: "100%", height: "80px", objectFit: "cover", borderRadius: "4px",
  },
  name: {
    marginTop: "6px", fontSize: "13px",
  },
  closeBtn: {
    marginTop: "10px",
    padding: "8px 16px",
    background: "#ef4444",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default MaterialPickerModal;
